import { axiosInstance, axiosCompanyPortalInstance } from "./";

const BULK_STATUS_VALIDATE = (status) =>
  (status >= 200 && status < 300) || status === 207;

const getAdminPayrollAdjustments = async ({ eventId, params }) =>
  await axiosInstance.get(`/events/${+eventId}/payroll_adjustments`, {
    params,
  });

const getCompanyPayrollAdjustments = async ({ eventId, params }) =>
  await axiosCompanyPortalInstance.get(
    `/events/${+eventId}/payroll_adjustments`,
    { params }
  );

const createAdminPayrollAdjustment = async ({ eventId, params }) =>
  await axiosInstance.post(`/events/${+eventId}/payroll_adjustments`, params, {
    handlerEnabled: false,
  });

const createCompanyPayrollAdjustment = async ({ eventId, params }) =>
  await axiosCompanyPortalInstance.post(
    `/events/${+eventId}/payroll_adjustments`,
    params,
    { handlerEnabled: false }
  );

const updateAdminPayrollAdjustment = async ({ eventId, id, params }) =>
  await axiosInstance.patch(
    `/events/${+eventId}/payroll_adjustments/${id}`,
    params
  );

const updateCompanyPayrollAdjustment = async ({ eventId, id, params }) =>
  await axiosCompanyPortalInstance.patch(
    `/events/${+eventId}/payroll_adjustments/${id}`,
    params
  );

const bulkCreateAdminPayrollAdjustments = async ({ eventId, params }) =>
  await axiosInstance.post(
    `/events/${+eventId}/payroll_adjustments/bulk_create`,
    params,
    { validateStatus: BULK_STATUS_VALIDATE, handlerEnabled: false }
  );

const bulkCreateCompanyPayrollAdjustments = async ({ eventId, params }) =>
  await axiosCompanyPortalInstance.post(
    `/events/${+eventId}/payroll_adjustments/bulk_create`,
    params,
    { validateStatus: BULK_STATUS_VALIDATE, handlerEnabled: false }
  );

const bulkUpdateAdminPayrollAdjustments = async ({ eventId, params }) =>
  await axiosInstance.patch(
    `/events/${+eventId}/payroll_adjustments/bulk_update`,
    params,
    { validateStatus: BULK_STATUS_VALIDATE }
  );

const bulkUpdateCompanyPayrollAdjustments = async ({ eventId, params }) =>
  await axiosCompanyPortalInstance.patch(
    `/events/${+eventId}/payroll_adjustments/bulk_update`,
    params,
    { validateStatus: BULK_STATUS_VALIDATE }
  );

export {
  getAdminPayrollAdjustments,
  getCompanyPayrollAdjustments,
  createAdminPayrollAdjustment,
  createCompanyPayrollAdjustment,
  updateAdminPayrollAdjustment,
  updateCompanyPayrollAdjustment,
  bulkCreateAdminPayrollAdjustments,
  bulkCreateCompanyPayrollAdjustments,
  bulkUpdateAdminPayrollAdjustments,
  bulkUpdateCompanyPayrollAdjustments,
};
